import DetailsCard from '../DetailsCard/DetailsCard';

export const CardConfig = ({ t, jobAlerts }) => {
  return [
    {
      id: '1',
      title: t('dashboard.settings.jobalerts'),
      subtitle: t('dashboard.settings.jobalertslabel'),
      details: <DetailsCard allAlerts={jobAlerts.data} cardStyleFade={jobAlerts.cardStyleFade} />,
      extraComponent: true,
      status: jobAlerts.status,
      dataList: jobAlerts.data,
      tooglerFunc: jobAlerts.tooglerFunc
    }
    // TODO uncomment when you are gonna work on this functionality
    // {
    //   id: '2',
    //   title: t('dashboard.settings.marketinginfo'),
    //   subtitle: t('dashboard.settings.marketinginfolabel'),
    //   details: 'coming soon..',
    //   extraComponent: false,
    //   status: false,
    //   dataList: [],
    //   tooglerFunc: null
    // },
    // {
    //   id: '3',
    //   title: t('dashboard.settings.tneupdates'),
    //   subtitle: t('dashboard.settings.tneupdateslabel'),
    //   details: 'coming soon....',
    //   extraComponent: false,
    //   status: false,
    //   dataList: [],
    //   tooglerFunc: null
    // }
  ];
};
